import WebPathService, {SubWebPathService} from "app/Service/System/WebPathService"
import SystemLayoutUiService, {SubscribeSystemLayoutUiService} from "app/Service/System/Layout/SystemLayoutUiService"
import TitleBarView from "app/WebView/Titlebar/TitleBarView"
import Logger from "logger/logger"
import React, {useEffect, useState} from "react"
import {useTranslation} from "react-i18next"
import EnvironmentService, {subscribeEnv} from "app/Service/System/EnvironmentService"
import SystemModuleService, {subscribeSystemModule} from "app/Service/System/Module/SystemModuleService"

function TitleBar() {

  const {t} = useTranslation()

  const {modulePath} = WebPathService([
    SubWebPathService.modulePath
  ], 'TitleBar')

  const {languageLoading} = EnvironmentService([
    subscribeEnv.language
  ], 'TitleBar')

  const {activeSystemModule} = SystemModuleService([
    subscribeSystemModule.activeSystemModule
  ], 'TitleBarController')

  const {isEditingLayout} = SystemLayoutUiService([
    SubscribeSystemLayoutUiService.editLayout,
  ], 'TitleBar')

  const [title, setTitle] = useState<string | undefined>()

  useEffect(() => {
    Logger('Element.TitleBar.init')
    return () => {
      Logger('Element.TitleBar.unloading')
    }
  }, [])

  useEffect(function setTitleBarTitle() {
    if (undefined === activeSystemModule) {
      if (title)
        setTitle(undefined)
      return
    }
    const moduleName = t(activeSystemModule.name, {ns: `Module.Modules`})
    setTitle(moduleName)

  }, [activeSystemModule, modulePath, languageLoading])

  return <TitleBarView title={title} isEditLayout={isEditingLayout}/>
}

export default TitleBar
